import { ApiResponseError } from "./type";
import { ROUTE_LOGOUT } from "@/constants/routes";
import { navigateTo } from "@/router/navigation";
import { AxiosRequestConfig, httpCommunicator } from "@aurora/services";
import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import { createApi } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import queryString from "query-string";

export const request: any = async ({
  count = 1,
  data,
  headers = {},
  method,
  params,
  responseType,
  url,
  withCredentials,
}: any) => {
  // try {
  const result = await httpCommunicator({
    data,
    headers,
    method: method || "get",
    params,
    paramsSerializer: (params: Record<string, unknown>) => {
      return queryString.stringify(params, {
        arrayFormat: "none",
        skipEmptyString: true,
        skipNull: true,
      });
    },
    responseType,
    url,
    withCredentials: withCredentials || false,
  });
  return { data: result.data };
  // } catch (axiosError) {
  //   const err = axiosError as AxiosError;
  //
  //   if (err.response?.status === 401) {
  //     // Ошибка авторизации
  //     // Пробуем обновить токен
  //     // todo: убираем временно refreshToken
  //     // await axios({
  //     //   data: null,
  //     //   headers,
  //     //   method: "get",
  //     //   params: null,
  //     //   responseType,
  //     //   url: API_AUTH_REFRESH,
  //     //   withCredentials: true,
  //     // });
  //     //
  //     // return await request({
  //     //   count: count + 1,
  //     //   data,
  //     //   headers,
  //     //   method,
  //     //   params,
  //     //   responseType,
  //     //   url,
  //     //   withCredentials,
  //     // });
  //   } else if (
  //     (err.response?.status === 401 && count === 3) ||
  //     err.response?.status === 500
  //   ) {
  //     console.log("Erorr", err);
  //   }
  //
  //   return;
  // }
};

// Add a request interceptor
httpCommunicator.interceptors.request.use(
  config => {
    if (config.url !== "/get-token") {
      const token = Cookies.get("accessToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
httpCommunicator.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  err => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    console.log("Interceptor Error", err);
    if (err.response?.status === 401) {
      navigateTo(ROUTE_LOGOUT);
    }

    return Promise.reject({
      error: {
        data: err.response?.data || err.message,
        status: err.response?.status || err.status,
      },
    });
  },
);

export const axiosBaseQuery = (
  { baseUrl }: { baseUrl: string } = { baseUrl: "" },
): BaseQueryFn<
  {
    url: string;
    method?: AxiosRequestConfig["method"];
    data?: AxiosRequestConfig["data"];
    params?: AxiosRequestConfig["params"];
    responseType?: AxiosRequestConfig["responseType"];
    headers?: AxiosRequestConfig["headers"];
    withCredentials?: AxiosRequestConfig["withCredentials"];
  },
  unknown,
  ApiResponseError
> => request;

export const api = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: "" }),
  endpoints: () => ({}),
  reducerPath: "api",
});
